import { render, staticRenderFns } from "./TrainingEventCreate.vue?vue&type=template&id=6b8f2df4"
import script from "./TrainingEventCreate.vue?vue&type=script&lang=js"
export * from "./TrainingEventCreate.vue?vue&type=script&lang=js"
import style0 from "./TrainingEventCreate.vue?vue&type=style&index=0&id=6b8f2df4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports